<p-table [value]="events" [paginator]="true" [rows]="10" class="mt-3" styleClass="p-datatable-overflow">

  <ng-template pTemplate="caption">
    <div class="flex justify-content-center">
      <button
        [label]="'misc.addEvent' | transloco"
        [disabled]="!selection"
        (click)="addNewEvent()"
        pButton
        icon="pi pi-plus"
      ></button>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th scope="col">{{'attribute.element' | transloco}}</th>
      <th scope="col">{{'attribute.event' | transloco}}</th>
      <th scope="col">{{'common.action' | transloco}}</th>
      <th scope="col" class="text-right">{{'common.actions' | transloco}}</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-event>
    <tr [class.p-highlight]="selection && (selection.id() === event.id)">
      <td (click)="changeSelectionById.emit(event.id)" class="cursor-pointer">
        <span class="p-column-title bold">{{ 'attribute.element'| transloco}}</span>
        {{event.id}}
      </td>
      <td>
        <span class="p-column-title bold">{{ 'attribute.event'| transloco}}</span>
        <p-dropdown
          [(ngModel)]="event.trigger"
          [options]="triggerOptions | translateLabels | async"
          [placeholder]="'misc.synopticModifierTypes.empty' | transloco"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
        ></p-dropdown>
      </td>
      <td>
        <span class="p-column-title bold">{{ 'common.action'| transloco}}</span>
        <p-dropdown
          *ngIf="event.trigger"
          [(ngModel)]="event.action.type"
          [options]="(
            event.trigger === 'click' ? actionOptionsClick :
            event.trigger === 'hover' ? actionOptionsHover :
            []
          ) | translateLabels | async"
          [placeholder]="'misc.synopticActionTypes.empty' | transloco"
          (ngModelChange)="event.action.args = generateDefaultArgsForAction($event); onEventsChange();"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
        ></p-dropdown>
      </td>
      <td>
        <span class="p-column-title bold">{{ 'common.actions'| transloco}}</span>
        <div class="flex justify-content-end">
          <button
            *ngIf="!event.action.type || event.action.type !== 'closePopup'"
            [disabled]="!event.action.type"
            (click)="startEditingAction(event)"
            pButton
            icon="pi pi-cog"
            class="ml-2 p-button-icon-only p-button-text py-1"
          ></button>
          <button
            (click)="duplicateEvent(event)"
            pButton
            icon="pi pi-clone"
            class="p-button-icon-only p-button-text py-1"
          ></button>
          <button
            (click)="removeEvent(event)"
            pButton
            icon="pi pi-trash"
            class="p-button-icon-only p-button-text py-1"
          ></button>
        </div>
      </td>
    </tr>
  </ng-template>

</p-table>
